export function compareId(id1: string, id2: string) {
  if (id1 === id2) {
    return 0;
  }

  if (id1.length === id2.length) {
    return id1 > id2 ? 1 : -1;
  } else {
    return id1.length > id2.length ? 1 : -1;
  }
}

export function compareNotifyId(id1: string, id2: string): number {
  try {
    const num1 = BigInt(id1);
    const num2 = BigInt(id2);

    if (num1 === num2) {
      return 0;
    }
    return num1 > num2 ? 1 : -1;
  } catch (error) {
    console.warn('Invalid ID format for numeric comparison:', id1, id2, error);
    if (id1 === id2) {
      return 0;
    }
    return id1 > id2 ? 1 : -1;
  }
}
